// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"02d91ed2","236":"f179a214","509":"a927b947","544":"15fb4f62","545":"0bcf230c","606":"c18569b8","685":"bb16983e","917":"d0232486"}[chunkId] + ".chunk.css";
};